module.exports = __webpack_public_path__ + "fonts/Figtree-Regular-083435b.ttf";